import axios from 'axios';

import { CompletionMessage } from '@common/types/api/completionMessageTypes';

import { processResponse } from './helpers';
import createResponseErrorInterceptor from './interceptors/responseInterceptor';

export interface IRestResponse {
	code: string | number;
	data: any;
	completion_message?: CompletionMessage | null;
}

const instance = axios.create({
	baseURL: process.env.ENV_CLIENT_API_URL,
});

instance.interceptors.response.use(
	processResponse,
	createResponseErrorInterceptor(instance),
);

export default instance;
